export const App_url = {
 image : {
    logo: `${window.location.origin}/logo.svg`,
    title: `${window.location.origin}/title.svg`,
    about_bg_img: `${window.location.origin}/kv_bottom.webp`,
    about_bg: `${window.location.origin}/about_bg.png`,
    about_1: `${window.location.origin}/about_01.webp`,
    about_2: `${window.location.origin}/about_02.webp`,
    about_3: `${window.location.origin}/about_3.png`,
    about_4: `${window.location.origin}/about_4.webp`,
    ling: `${window.location.origin}/ling.webp`,
    collection_1: `${window.location.origin}/collection_1.webp`,
    collection_2: `${window.location.origin}/collection_2.webp`,
    collection_3: `${window.location.origin}/collection_3.webp`,
    collection_4: `${window.location.origin}/collection_4.webp`,
    collection_5: `${window.location.origin}/collection_5.webp`,
    collection_6: `${window.location.origin}/collection_6.webp`,
    list_bg: `${window.location.origin}/list_bg.webp`,
    list_1: `${window.location.origin}/list_1.webp`,
    list_2: `${window.location.origin}/list_2.webp`,
    list_3: `${window.location.origin}/list_3.webp`,
    list_4: `${window.location.origin}/list_4.webp`,
    list_5: `${window.location.origin}/list_5.webp`,
    list_6: `${window.location.origin}/list_6.webp`,
    list_7: `${window.location.origin}/list_7.webp`,
    list_8: `${window.location.origin}/list_8.webp`,
    list_9: `${window.location.origin}/list_9.webp`,
    list_10: `${window.location.origin}/list_10.webp`,
    list_11: `${window.location.origin}/list_11.webp`,
    list_12: `${window.location.origin}/list_12.webp`,
    list_13: `${window.location.origin}/list_13.webp`,
    list_14: `${window.location.origin}/list_14.webp`,
    list_15: `${window.location.origin}/list_15.webp`,
    list_16: `${window.location.origin}/list_16.webp`,
    contact_bg: `${window.location.origin}/contact_form_bg.jpg`,
    form_logo: `${window.location.origin}/form_logo.webp`,
    exclude_l: `${window.location.origin}/exclude-l.svg`,
    exclude_r: `${window.location.origin}/exclude-r.svg`,
    outline: `${window.location.origin}/outline.png`,
    strip: `${window.location.origin}/strip.svg`,
    draw_bg: `${window.location.origin}/draw_bg.webp`,
    draw_title: `${window.location.origin}/draw_title-red.png`,
    footer_logo: `${window.location.origin}/footer.svg`,
 }
}

export const collectionItems = [
   { id: 1, title: 'Scars of Domination', image: App_url.image.collection_1, height: '560' },
   { id: 2, title: 'Thorned Regalia', image: App_url.image.collection_2, style: 'h-[300px] w-[200px]' },
   { id: 3, title: 'Vine of Oaths', image: App_url.image.collection_3, height: '[800px]' },
   { id: 4, title: 'Crowns Eclipse', image: App_url.image.collection_4, style: 'h-[300px] w-[200px]', classes: "justify-self-start items-end left-0 bottom-0 translate-y-[calc(100%+1.6rem)]" },
   { id: 5, title: 'Silent Conqueror', image: App_url.image.collection_5, style: 'h-[300px] w-[200px]' },
   { id: 6, title: 'Spiny Velvet', image: App_url.image.collection_6, width: '1024', height: '574' },
]

export const ExperienceList = [
   { id: 1, date: "2024 12 07", collect: "The Throned Gathering", name: "Opening Night", image: App_url.image.list_1},
   { id: 2, date: "2025 01 18", collect: "Dominion Briefing", name: "Concept Salon", image: App_url.image.list_2},
   { id: 3, date: "2025 02 15", collect: "Thorn Atelier", name: "Bespoke Craft Session", image: App_url.image.list_3},
   { id: 4, date: "2025 03 18", collect: "Shadows & Crowns", name: "Immersive Exhibition", image: App_url.image.list_4},
   { id: 5, date: "2025 03 30", collect: "Ceremony of Fractures", name: "Live Performance", image: App_url.image.list_5},
   { id: 6, date: "2025 04 05", collect: "Right of Thorns", name: "Membership Induction Ritual", image: App_url.image.list_6},
   { id: 7, date: "2025 05 10", collect: "Blood & Velvet", name: "Secret Party", image: App_url.image.list_7},
   { id: 8, date: "2025 06 14", collect: "Obsidian Portrait", name: "Bespoke Craft Session", image: App_url.image.list_8},
   { id: 9, date: "2025 07 12", collect: "Vine of Oaths", name: "Collector's Private Salon", image: App_url.image.list_9},
   { id: 10, date: "2025 08 09", collect: "Ash & Ivory", name: "Exhibition of Raw Elements", image: App_url.image.list_10},
   { id: 11, date: "2025 08 23", collect: "Silent Conqueror", name: "Club Night", image: App_url.image.list_11},
   { id: 12, date: "2025 09 13", collect: "Crowns Archive", name: "Viewing of Unreleased Relics", image: App_url.image.list_12},
   { id: 13, date: "2025 10 18", collect: "The Silent Auction", name: "Club Night", image: App_url.image.list_13},
   { id: 14, date: "2025 10 31", collect: "Veil & Thorn", name: "Masquerade of Hidden Crowns", image: App_url.image.list_14},
   { id: 15, date: "2025 11 22", collect: "The Silent Auction", name: "Club Night", image: App_url.image.list_15},
   { id: 16, date: "2025 12 06", collect: "Night of the First Thorn", name: "Brand Anniversary Ritual", image: App_url.image.list_16},
]

export const FormKeywords = [
   { id: 1, name: "Power", style: "opacity-70 translate-x-[-538px] translate-y-[-183.4px] w-[70px] h-[20px]", x: "-30vw", y: "-15vh"},
   { id: 2, name: "Sacrifice", style: "top-[15%] left-[15%] opacity-70 translate-x-[420px] translate-y-[-147.4px] w-[102px] h-[20px]", x: "30vw", y: "-15vh"},
   { id: 3, name: "Oath in Shadows", style: "top-[18%] left-[16%] opacity-70 translate-x-[-278px] translate-y-[122.4px] w-[183px] h-[20px]", x: "-30vw", y: "15vh"},
   { id: 4, name: "Rebellion", style: "top-[40%] left-[20%] opacity-70 translate-x-[411px] translate-y-[428px] w-[111px] h-[20px]", x: "30vw", y: "50vh"},
   { id: 5, name: "Reign in silence", style: "top-[65%] left-[16%] opacity-70 translate-x-[430px] translate-y-[61px] w-[175px] h-[20px]", x: "20vw", y: "25vh"},
   { id: 6, name: "Ascend", style: "top-[35%] left-[22%] opacity-70 translate-x-[-166px] translate-y-[244px] w-[80px] h-[20px]", x: "-15vw", y: "35vh"},
   { id: 7, name: "Ritual", style: "top-[50%] left-[34%] opacity-70 translate-x-[-399px] translate-y-[342px] w-[73.4px] h-[20px] max-w-[73.4px] max-h-[20px] min-w-[73.4px] min-h-[20px]", x: "-30vw", y: "50vh"},
]